if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);

      window.addEventListener('shopify:section:load', e => {
        this.initSlider(swiperOptions);
      });
    }

    initSlider(swiperOptions) {
      let sliderOptions = {
        slidesPerView: swiperOptions.slidesPerView || 1,
        resistanceRatio: 0.72,
        loop: swiperOptions.loop || false,
        allowTouchMove: swiperOptions.allowTouchMove || true,
        autoplay: swiperOptions.autoplay || false,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 'auto',
            loop: swiperOptions.loopDesktop !== undefined ? swiperOptions.loopDesktop : (swiperOptions.loop || false),
          }
        }
      };

      this.slider = new Swiper(this, sliderOptions);
      this.initPausePlayButton();
    }

    initPausePlayButton() {
      const wrapper = this.closest('.announcement-bar__wrapper');
      if (!wrapper) return;

      const btn = wrapper.querySelector('.announcement-bar__pause-play');
      if (!btn) return;

      btn.addEventListener('click', () => {
        const isPaused = btn.classList.contains('is-paused');
        if (isPaused) {
          this.slider.autoplay.start();
          btn.classList.remove('is-paused');
          btn.setAttribute('aria-label', 'Pause slideshow');
          btn.setAttribute('aria-pressed', 'false');
        } else {
          this.slider.autoplay.stop();
          btn.classList.add('is-paused');
          btn.setAttribute('aria-label', 'Play slideshow');
          btn.setAttribute('aria-pressed', 'true');
        }
      });
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
